/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export const HubAlphaSchedulerTaskStatus = {
    QUEUED: "QUEUED",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    STOPPING: "STOPPING",
    STOPPED: "STOPPED",
    FAILED: "FAILED",
    DONE: "DONE",
};
export const HubAnnotationOrigin = {
    EXTERNAL: "EXTERNAL",
    MANUAL: "MANUAL",
    MODEL: "MODEL",
};
export const HubAnnotationSourceKind = {
    USER: "USER",
    JOB: "JOB",
    DEPLOYMENT: "DEPLOYMENT",
    UNKNOWN: "UNKNOWN",
    CUSTOM: "CUSTOM",
};
export const HubAnnotationStatus = {
    COMPLETE: "COMPLETE",
    PARTIAL: "PARTIAL",
    NONE: "NONE",
};
export const HubArrayDataType = {
    Bool: "Bool",
    I8: "I8",
    I16: "I16",
    I32: "I32",
    I64: "I64",
    U8: "U8",
    U16: "U16",
    U32: "U32",
    U64: "U64",
    F16: "F16",
    F32: "F32",
    F64: "F64",
};
export const HubAuthPermissions = {
    PROJECT_CREATION: "PROJECT_CREATION",
    DATA_UPLOAD: "DATA_UPLOAD",
    DATA_LABELING: "DATA_LABELING",
    LABELING_REVIEW: "LABELING_REVIEW",
    MODEL_CREATION: "MODEL_CREATION",
    INFERENCE: "INFERENCE",
    SYSTEM_MANAGEMENT: "SYSTEM_MANAGEMENT",
    EDGE: "EDGE",
};
export const HubBrandingItemId = {
    Logo: "logo",
    Favicon: "favicon",
    PrimaryColor: "primaryColor",
    CookiePolicy: "cookiePolicy",
    PrivacyPolicy: "privacyPolicy",
    TermsAndConditions: "termsAndConditions",
    OnScreenText: "onScreenText",
    DocumentationUrl: "documentationUrl",
};
export const HubBrandingType = {
    Color: "color",
    File: "file",
    Url: "url",
};
export const HubBuildState = {
    CHECKING_COMPATIBILITY: "CHECKING_COMPATIBILITY",
    PENDING: "PENDING",
    READY: "READY",
    FAILED: "FAILED",
    DELETING: "DELETING",
    DELETED: "DELETED",
};
export const HubCameraConfigStatus = {
    VALID: "VALID",
    INVALID: "INVALID",
};
export const HubCameraStatus = {
    IDLE: "IDLE",
    IN_USE: "IN_USE",
};
export const HubCameraType = {
    BASLER: "BASLER",
    ALLIED_VISION: "ALLIED_VISION",
    GENICAM: "GENICAM",
};
export const HubDatapointFieldSourceType = {
    Dataset: "Dataset",
};
export const HubDatapointFieldType = {
    Integer: "Integer",
    Float: "Float",
    Boolean: "Boolean",
    String: "String",
    Class: "Class",
    Datetime: "Datetime",
    UUID: "UUID",
    SampleIDs: "Sample IDs",
};
export const HubDefaultExamplePickingStrategy = {
    LATEST: "LATEST",
    RANDOM: "RANDOM",
    SELECTION: "SELECTION",
    SINGLESOURCE: "SINGLESOURCE",
};
export const HubDeploymentStatus = {
    QUEUED: "QUEUED",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    STOPPING: "STOPPING",
    STOPPED: "STOPPED",
    FAILED: "FAILED",
};
export const HubExamplePickingStrategy = {
    RANDOM: "RANDOM",
    LATEST: "LATEST",
};
export const HubExampleStreamDefinitionType = {
    SAMPLE_DEFINITION: "SAMPLE_DEFINITION",
    EXAMPLE_DEFINITION: "EXAMPLE_DEFINITION",
};
export const HubExampleStreamRunningTaskKind = {
    JOB: "JOB",
    DEPLOYMENT: "DEPLOYMENT",
};
export const HubExampleStreamStatus = {
    IDLE: "IDLE",
    IN_USE: "IN_USE",
    RECORDING: "RECORDING",
    VALIDATING: "VALIDATING",
    INFERENCE: "INFERENCE",
    UNAVAILABLE: "UNAVAILABLE",
    INVALID: "INVALID",
};
export const HubFileEncoding = {
    Plain: "plain",
    Base64: "base64",
};
export const HubImageMode = {
    LU8: "L_U8",
    LF32: "L_F32",
    LF64: "L_F64",
    LAU8: "LA_U8",
    LAF32: "LA_F32",
    LAF64: "LA_F64",
    RGBU8: "RGB_U8",
    RGBF32: "RGB_F32",
    RGBF64: "RGB_F64",
    RGBAU8: "RGBA_U8",
    RGBAF32: "RGBA_F32",
    RGBAF64: "RGBA_F64",
    BGRU8: "BGR_U8",
    BGRF32: "BGR_F32",
    BGRF64: "BGR_F64",
    BGRAU8: "BGRA_U8",
    BGRAF32: "BGRA_F32",
    BGRAF64: "BGRA_F64",
    YCbCrU8: "YCbCr_U8",
    BayerRGU8: "BayerRG_U8",
    BayerRGU10: "BayerRG_U10",
    BayerRGU12: "BayerRG_U12",
    JPEG: "JPEG",
    PNG: "PNG",
    GIF: "GIF",
    BMP: "BMP",
};
export const HubJobKind = {
    ModelTraining: "modelTraining",
    ModelFinetuning: "modelFinetuning",
    AnnotationPrediction: "annotationPrediction",
    AnnotationComparison: "annotationComparison",
    CameraCalibration: "cameraCalibration",
    Recording: "recording",
    Custom: "custom",
};
export const HubJobStatus = {
    QUEUED: "QUEUED",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    DONE: "DONE",
    FAILED: "FAILED",
    STOPPING: "STOPPING",
    STOPPED: "STOPPED",
};
export const HubLogLevel = {
    SYSTEM_STATUS: "SYSTEM_STATUS",
    DEBUG: "DEBUG",
    INFO: "INFO",
    WARNING: "WARNING",
    ERROR: "ERROR",
};
export const HubMetricWidget = {
    Scalar: "Scalar",
    Line: "Line",
    ConfusionMatrix: "Confusion Matrix",
    Bar: "Bar",
    Histogram: "Histogram",
    ROC: "ROC",
    ScoreGraph: "Score Graph",
    Percentage: "Percentage",
};
export const HubPixelDataLayout = {
    HeightWidthChannels: "HeightWidthChannels",
    ChannelsHeightWidth: "ChannelsHeightWidth",
};
export const HubPlatformConnectionStatus = {
    CONNECTING: "CONNECTING",
    HEALTHY: "HEALTHY",
    UNHEALTHY: "UNHEALTHY",
    UNKNOWN: "UNKNOWN",
    DISCONNECTED: "DISCONNECTED",
};
export const HubPlatformDeploymentActualStatus = {
    PULLED: "PULLED",
    RUNNING: "RUNNING",
    STOPPED: "STOPPED",
    PULLING: "PULLING",
    STARTING: "STARTING",
    STOPPING: "STOPPING",
    ERROR: "ERROR",
};
export const HubPlatformDeploymentCreateErrorCode = {
    PLATFORM_DEPLOYMENT_ALREADY_EXISTS: "PLATFORM_DEPLOYMENT_ALREADY_EXISTS",
    CHILD_PLATFORM_DOES_NOT_EXIST: "CHILD_PLATFORM_DOES_NOT_EXIST",
    PARENT_PLATFORM_DOES_NOT_EXIST: "PARENT_PLATFORM_DOES_NOT_EXIST",
    PARENT_DEPLOYMENT_DOES_NOT_EXIST: "PARENT_DEPLOYMENT_DOES_NOT_EXIST",
};
export const HubPlatformDeploymentDesiredStatus = {
    PULLED: "PULLED",
    RUNNING: "RUNNING",
    STOPPED: "STOPPED",
};
export const HubPlatformDeploymentErrorCode = {
    IMPORT_FAILED: "IMPORT_FAILED",
    IMPORT_STOPPED: "IMPORT_STOPPED",
    DEPLOYMENT_START_FAILED: "DEPLOYMENT_START_FAILED",
    DEPLOYMENT_STOP_FAILED: "DEPLOYMENT_STOP_FAILED",
};
export const HubPlatformDeploymentRole = {
    PARENT: "PARENT",
    CHILD: "CHILD",
};
export const HubResourceKind = {
    PARAMETERS: "PARAMETERS",
    EXAMPLES: "EXAMPLES",
    DATASET: "DATASET",
    DATAPOOL: "DATAPOOL",
    MODEL: "MODEL",
    BLOB: "BLOB",
};
export const HubSplitStrategy = {
    RANDOM: "RANDOM",
    STRATIFIED: "STRATIFIED",
};
export const HubStorageCapacityServiceId = {
    Algorithm: "algorithm",
    Data: "data",
    Database: "database",
    Resources: "resources",
};
export const HubStorageCapacityStatus = {
    NORMAL: "NORMAL",
    WARNING: "WARNING",
    ALARM: "ALARM",
};
export const HubWorkflowStatus = {
    QUEUED: "QUEUED",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    STOPPING: "STOPPING",
    DELETING: "DELETING",
    STOPPED: "STOPPED",
    DONE: "DONE",
    FAILED: "FAILED",
};
import axios from "axios";
import qs from "qs";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "/hub/api/v1",
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "indices" }),
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;
        if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
            body = this.createFormData(body);
        }
        if (type === ContentType.UrlEncoded && body && body !== null && typeof body === "object") {
            body = qs.stringify(body);
        }
        if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
            body = JSON.stringify(body);
        }
        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}
/**
 * @title RVAI Hub
 * @version 5.12.0
 * @baseUrl /hub/api/v1
 */
export class Api extends HttpClient {
    algorithms = {
        /**
         * @description List algorithms. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name ListAlgorithms
         * @summary List Algorithms
         * @request GET:/algorithms
         * @secure
         */
        listAlgorithms: (query, params = {}) => this.request({
            path: `/algorithms`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List algorithm fields. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name ListAlgorithmFields
         * @summary List Algorithm Fields
         * @request GET:/algorithms/fields
         * @secure
         */
        listAlgorithmFields: (params = {}) => this.request({
            path: `/algorithms/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a new algorithm by uploading thumbnail and algorithm spec. The algorithm image should be prebuilt and pushed to the docker registry. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name CreateNewAlgorithmPrebuilt
         * @summary Create New Algorithm Prebuilt
         * @request POST:/algorithms/prebuilt
         * @secure
         */
        createNewAlgorithmPrebuilt: (data, query, params = {}) => this.request({
            path: `/algorithms/prebuilt`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithms registry details. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmsRegistry
         * @summary Get Algorithms Registry
         * @request GET:/algorithms/registry
         * @secure
         */
        getAlgorithmsRegistry: (params = {}) => this.request({
            path: `/algorithms/registry`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List algorithm types. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name ListAlgorithmTypes
         * @summary List Algorithm Types
         * @request GET:/algorithms/types
         * @secure
         */
        listAlgorithmTypes: (params = {}) => this.request({
            path: `/algorithms/types`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm type. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmType
         * @summary Get Algorithm Type
         * @request GET:/algorithms/types/{algorithm_type}
         * @secure
         */
        getAlgorithmType: (algorithmType, params = {}) => this.request({
            path: `/algorithms/types/${algorithmType}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm type thumbnail. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmTypeThumbnail
         * @summary Get Algorithm Type Thumbnail
         * @request GET:/algorithms/types/{algorithm_type}/thumbnail
         * @secure
         */
        getAlgorithmTypeThumbnail: (algorithmType, params = {}) => this.request({
            path: `/algorithms/types/${algorithmType}/thumbnail`,
            method: "GET",
            secure: true,
            format: "blob",
            ...params,
        }),
        /**
         * @description List daemons for algorithm. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags daemons
         * @name ListAlgorithmDaemons
         * @summary List Algorithm Daemons
         * @request GET:/algorithms/{algorithm_id}/{algorithm_version}/daemons
         * @secure
         */
        listAlgorithmDaemons: (algorithmId, algorithmVersion, params = {}) => this.request({
            path: `/algorithms/${algorithmId}/${algorithmVersion}/daemons`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a daemon. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags daemons
         * @name GetDaemon
         * @summary Get Daemon
         * @request GET:/algorithms/{algorithm_id}/{algorithm_version}/daemons/{definition_id}
         * @secure
         */
        getDaemon: (algorithmId, algorithmVersion, definitionId, params = {}) => this.request({
            path: `/algorithms/${algorithmId}/${algorithmVersion}/daemons/${definitionId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete an algorithm. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name DeleteAlgorithm
         * @summary Delete Algorithm
         * @request DELETE:/algorithms/{id}/{version}
         * @secure
         */
        deleteAlgorithm: (id, version, query, params = {}) => this.request({
            path: `/algorithms/${id}/${version}`,
            method: "DELETE",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithm
         * @summary Get Algorithm
         * @request GET:/algorithms/{id}/{version}
         * @secure
         */
        getAlgorithm: (id, version, params = {}) => this.request({
            path: `/algorithms/${id}/${version}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm definition. If the original flag is set to True, the definition will be returned in the same schema version as it was created by the originating algorithm. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmDefinition
         * @summary Get Algorithm Definition
         * @request GET:/algorithms/{id}/{version}/definition
         * @secure
         */
        getAlgorithmDefinition: (id, version, query, params = {}) => this.request({
            path: `/algorithms/${id}/${version}/definition`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm thumbnail. Supports authorization via ?token. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmThumbnail
         * @summary Get Algorithm Thumbnail
         * @request GET:/algorithms/{id}/{version}/thumbnail
         * @secure
         */
        getAlgorithmThumbnail: (id, version, query, params = {}) => this.request({
            path: `/algorithms/${id}/${version}/thumbnail`,
            method: "GET",
            query: query,
            secure: true,
            format: "blob",
            ...params,
        }),
    };
    alpha = {
        /**
         * @description Retrieve calibration resources for the specified camera. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags alpha, cameras
         * @name ListCameraCalibrationResources
         * @summary List Camera Calibration Resources
         * @request GET:/alpha/cameras/{camera_id}/calibration-resources
         * @secure
         */
        listCameraCalibrationResources: (cameraId, query, params = {}) => this.request({
            path: `/alpha/cameras/${cameraId}/calibration-resources`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description If there is a calibration resource for a specified example stream in a project, return the most recent one. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags alpha, example_streams
         * @name ListProjectCalibrationResourcesPerCameraConfig
         * @summary List Project Calibration Resources Per Camera Config
         * @request GET:/alpha/example-streams/{example_stream_id}/calibration-resources/{project_id}/most-recent
         * @secure
         */
        listProjectCalibrationResourcesPerCameraConfig: (projectId, exampleStreamId, query, params = {}) => this.request({
            path: `/alpha/example-streams/${exampleStreamId}/calibration-resources/${projectId}/most-recent`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags alpha, scheduler
         * @name ListSchedulerTasks
         * @summary List Scheduler Tasks
         * @request GET:/alpha/scheduler/tasks
         * @secure
         */
        listSchedulerTasks: (params = {}) => this.request({
            path: `/alpha/scheduler/tasks`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags alpha, scheduler
         * @name GetSchedulerEvents
         * @summary Get Scheduler Events
         * @request GET:/alpha/scheduler/tasks/sse
         * @secure
         */
        getSchedulerEvents: (params = {}) => this.request({
            path: `/alpha/scheduler/tasks/sse`,
            method: "GET",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags alpha, scheduler
         * @name SaveSchedulerTaskLogs
         * @summary Save Scheduler Task Logs
         * @request POST:/alpha/scheduler/tasks/{task_id}/logs
         * @secure
         */
        saveSchedulerTaskLogs: (taskId, data, params = {}) => this.request({
            path: `/alpha/scheduler/tasks/${taskId}/logs`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags alpha, scheduler
         * @name SetSchedulerTaskStatus
         * @summary Set Scheduler Task Status
         * @request PATCH:/alpha/scheduler/tasks/{task_id}/status
         * @secure
         */
        setSchedulerTaskStatus: (taskId, data, params = {}) => this.request({
            path: `/alpha/scheduler/tasks/${taskId}/status`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    branding = {
        /**
         * @description Full reset to defaults for the entire branding configuration. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags branding
         * @name ResetToDefaults
         * @summary Reset To Defaults
         * @request DELETE:/branding
         * @secure
         */
        resetToDefaults: (params = {}) => this.request({
            path: `/branding`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags branding
         * @name UpdateBranding
         * @summary Update Branding
         * @request PUT:/branding
         * @secure
         */
        updateBranding: (data, params = {}) => this.request({
            path: `/branding`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Returns a list of all the branding items **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags branding
         * @name GetBrandingFields
         * @summary Get Branding Fields
         * @request GET:/branding/fields
         * @secure
         */
        getBrandingFields: (params = {}) => this.request({
            path: `/branding/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Import a branding configuration from a JSON file. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags branding
         * @name ImportBrandingConfig
         * @summary Import Branding Config
         * @request POST:/branding/import
         * @secure
         */
        importBrandingConfig: (data, query, params = {}) => this.request({
            path: `/branding/import`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Bulk update the branding configuration. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags branding
         * @name BulkUpdateBranding
         * @summary Bulk Update Branding
         * @request PUT:/branding/json
         * @secure
         */
        bulkUpdateBranding: (data, query, params = {}) => this.request({
            path: `/branding/json`,
            method: "PUT",
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Returns all the overridden branding items. If an item is None, the default (robovision) branding should be shown.
         *
         * @tags branding
         * @name GetPublicBranding
         * @summary Get Public Branding
         * @request GET:/branding/public
         * @secure
         */
        getPublicBranding: (params = {}) => this.request({
            path: `/branding/public`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    cameras = {
        /**
         * @description List all cameras. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name ListCameras
         * @summary List Cameras
         * @request GET:/cameras
         * @secure
         */
        listCameras: (query, params = {}) => this.request({
            path: `/cameras`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a camera. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name CreateCamera
         * @summary Create Camera
         * @request POST:/cameras
         * @secure
         */
        createCamera: (data, params = {}) => this.request({
            path: `/cameras`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a camera. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name DeleteCamera
         * @summary Delete Camera
         * @request DELETE:/cameras/{camera_id}
         * @secure
         */
        deleteCamera: (cameraId, query, params = {}) => this.request({
            path: `/cameras/${cameraId}`,
            method: "DELETE",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get camera. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name GetCamera
         * @summary Get Camera
         * @request GET:/cameras/{camera_id}
         * @secure
         */
        getCamera: (cameraId, params = {}) => this.request({
            path: `/cameras/${cameraId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a camera. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name UpdateCamera
         * @summary Update Camera
         * @request PATCH:/cameras/{camera_id}
         * @secure
         */
        updateCamera: (cameraId, data, params = {}) => this.request({
            path: `/cameras/${cameraId}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Get camera config. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name GetCameraConfig
         * @summary Get Camera Config
         * @request GET:/cameras/{camera_id}/config
         * @secure
         */
        getCameraConfig: (cameraId, params = {}) => this.request({
            path: `/cameras/${cameraId}/config`,
            method: "GET",
            secure: true,
            ...params,
        }),
        /**
         * @description Update camera activity. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name UpdateCameraStatus
         * @summary Update Camera Status
         * @request PUT:/cameras/{camera_id}/status
         * @secure
         */
        updateCameraStatus: (cameraId, query, params = {}) => this.request({
            path: `/cameras/${cameraId}/status`,
            method: "PUT",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name GetCameraThumbnail
         * @summary Get Camera Thumbnail
         * @request GET:/cameras/{camera_id}/thumbnail
         * @secure
         */
        getCameraThumbnail: (cameraId, params = {}) => this.request({
            path: `/cameras/${cameraId}/thumbnail`,
            method: "GET",
            secure: true,
            format: "blob",
            ...params,
        }),
    };
    classes = {
        /**
         * @description Delete a class. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags global_classes
         * @name DeleteClasses
         * @summary Delete Classes
         * @request DELETE:/classes
         * @secure
         */
        deleteClasses: (data, params = {}) => this.request({
            path: `/classes`,
            method: "DELETE",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List classess. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags global_classes
         * @name ListClasses
         * @summary List Classes
         * @request GET:/classes
         * @secure
         */
        listClasses: (query, params = {}) => this.request({
            path: `/classes`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create classes. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags global_classes
         * @name CreateClasses
         * @summary Create Classes
         * @request POST:/classes
         * @secure
         */
        createClasses: (data, params = {}) => this.request({
            path: `/classes`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List classes fields. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags global_classes
         * @name ListClassesFields
         * @summary List Classes Fields
         * @request GET:/classes/fields
         * @secure
         */
        listClassesFields: (params = {}) => this.request({
            path: `/classes/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a class. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags global_classes
         * @name DeleteClass
         * @summary Delete Class
         * @request DELETE:/classes/{id}
         * @secure
         */
        deleteClass: (id, params = {}) => this.request({
            path: `/classes/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get class. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags global_classes
         * @name GetClass
         * @summary Get Class
         * @request GET:/classes/{id}
         * @secure
         */
        getClass: (id, params = {}) => this.request({
            path: `/classes/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a class. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags global_classes
         * @name UpdateClass
         * @summary Update Class
         * @request PUT:/classes/{id}
         * @secure
         */
        updateClass: (id, data, params = {}) => this.request({
            path: `/classes/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    clusters = {
        /**
         * @description Get compute clusters information.
         *
         * @tags monitor
         * @name GetComputeClusters
         * @summary Get Compute Clusters
         * @request GET:/clusters
         * @secure
         */
        getComputeClusters: (params = {}) => this.request({
            path: `/clusters`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    config = {
        /**
         * @description Modify platform config. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags monitor
         * @name ModifyPlatformConfig
         * @summary Modify Platform Config
         * @request POST:/config
         * @secure
         */
        modifyPlatformConfig: (data, params = {}) => this.request({
            path: `/config`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    customAnnotationSources = {
        /**
         * @description List custom annotation sources. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name ListCustomAnnotationSources
         * @summary List Custom Annotation Sources
         * @request GET:/custom-annotation-sources
         * @secure
         */
        listCustomAnnotationSources: (query, params = {}) => this.request({
            path: `/custom-annotation-sources`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a custom annotation source. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name CreateCustomAnnotationSource
         * @summary Create Custom Annotation Source
         * @request POST:/custom-annotation-sources
         * @secure
         */
        createCustomAnnotationSource: (data, params = {}) => this.request({
            path: `/custom-annotation-sources`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get custom annotation source by name. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name GetCustomAnnotationSourceByName
         * @summary Get Custom Annotation Source By Name
         * @request GET:/custom-annotation-sources/name/{name}
         * @secure
         */
        getCustomAnnotationSourceByName: (name, params = {}) => this.request({
            path: `/custom-annotation-sources/name/${name}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a custom annotation source. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name DeleteCustomAnnotationSource
         * @summary Delete Custom Annotation Source
         * @request DELETE:/custom-annotation-sources/{id}
         * @secure
         */
        deleteCustomAnnotationSource: (id, params = {}) => this.request({
            path: `/custom-annotation-sources/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get custom annotation source. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name GetCustomAnnotationSource
         * @summary Get Custom Annotation Source
         * @request GET:/custom-annotation-sources/{id}
         * @secure
         */
        getCustomAnnotationSource: (id, params = {}) => this.request({
            path: `/custom-annotation-sources/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a custom annotation source. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name UpdateCustomAnnotationSource
         * @summary Update Custom Annotation Source
         * @request PUT:/custom-annotation-sources/{id}
         * @secure
         */
        updateCustomAnnotationSource: (id, data, params = {}) => this.request({
            path: `/custom-annotation-sources/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List custom annotation source fields. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name ListCustomAnnotationSourceFields
         * @summary List Custom Annotation Source Fields
         * @request GET:/custom-annotation_sources/fields
         * @secure
         */
        listCustomAnnotationSourceFields: (params = {}) => this.request({
            path: `/custom-annotation_sources/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    daemons = {
        /**
         * @description List daemons. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags daemons
         * @name ListDaemons
         * @summary List Daemons
         * @request GET:/daemons
         * @secure
         */
        listDaemons: (params = {}) => this.request({
            path: `/daemons`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    datapools = {
        /**
         * @description List datapools. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListDatapools
         * @summary List Datapools
         * @request GET:/datapools
         * @secure
         */
        listDatapools: (query, params = {}) => this.request({
            path: `/datapools`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a datapool in a project. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name CreateDatapool
         * @summary Create Datapool
         * @request POST:/datapools
         * @secure
         */
        createDatapool: (data, params = {}) => this.request({
            path: `/datapools`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List datapool fields. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListDatapoolFields
         * @summary List Datapool Fields
         * @request GET:/datapools/fields
         * @secure
         */
        listDatapoolFields: (params = {}) => this.request({
            path: `/datapools/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete datapool. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datapools
         * @name DeleteDatapool
         * @summary Delete Datapool
         * @request DELETE:/datapools/{datapool_id}
         * @secure
         */
        deleteDatapool: (datapoolId, params = {}) => this.request({
            path: `/datapools/${datapoolId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get datapool. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name GetDatapool
         * @summary Get Datapool
         * @request GET:/datapools/{datapool_id}
         * @secure
         */
        getDatapool: (datapoolId, query, params = {}) => this.request({
            path: `/datapools/${datapoolId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get classes of this datapool. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name GetDatapoolClasses
         * @summary Get Datapool Classes
         * @request GET:/datapools/{datapool_id}/classes
         * @secure
         */
        getDatapoolClasses: (datapoolId, params = {}) => this.request({
            path: `/datapools/${datapoolId}/classes`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update classes of this datapool. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags datapools
         * @name UpdateDatapoolClasses
         * @summary Update Datapool Classes
         * @request PUT:/datapools/{datapool_id}/classes
         * @secure
         */
        updateDatapoolClasses: (datapoolId, data, params = {}) => this.request({
            path: `/datapools/${datapoolId}/classes`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a dataset. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name CreateDataset
         * @summary Create Dataset
         * @request POST:/datapools/{datapool_id}/datasets
         * @secure
         */
        createDataset: (datapoolId, data, params = {}) => this.request({
            path: `/datapools/${datapoolId}/datasets`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a dataset split. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name CreateSplit
         * @summary Create Split
         * @request POST:/datapools/{datapool_id}/datasets/splits
         * @secure
         */
        createSplit: (datapoolId, data, params = {}) => this.request({
            path: `/datapools/${datapoolId}/datasets/splits`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List datapool sources for filtered samples. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListFilteredDatapoolSources
         * @summary List Filtered Datapool Sources
         * @request POST:/datapools/{datapool_id}/filtered-sources
         * @secure
         */
        listFilteredDatapoolSources: (datapoolId, data, params = {}) => this.request({
            path: `/datapools/${datapoolId}/filtered-sources`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List datapool sources. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListDatapoolSources
         * @summary List Datapool Sources
         * @request GET:/datapools/{datapool_id}/sources
         * @secure
         */
        listDatapoolSources: (datapoolId, query, params = {}) => this.request({
            path: `/datapools/${datapoolId}/sources`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
    };
    datasets = {
        /**
         * @description List datasets. **Accepted permissions:** * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datasets
         * @name ListDatasets
         * @summary List Datasets
         * @request GET:/datasets
         * @secure
         */
        listDatasets: (query, params = {}) => this.request({
            path: `/datasets`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List dataset fields. **Accepted permissions:** * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datasets
         * @name ListDatasetFields
         * @summary List Dataset Fields
         * @request GET:/datasets/fields
         * @secure
         */
        listDatasetFields: (params = {}) => this.request({
            path: `/datasets/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete dataset. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name DeleteDataset
         * @summary Delete Dataset
         * @request DELETE:/datasets/{dataset_id}
         * @secure
         */
        deleteDataset: (datasetId, params = {}) => this.request({
            path: `/datasets/${datasetId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get dataset. **Accepted permissions:** * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datasets
         * @name GetDataset
         * @summary Get Dataset
         * @request GET:/datasets/{dataset_id}
         * @secure
         */
        getDataset: (datasetId, query, params = {}) => this.request({
            path: `/datasets/${datasetId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a dataset. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name UpdateDataset
         * @summary Update Dataset
         * @request PATCH:/datasets/{dataset_id}
         * @secure
         */
        updateDataset: (datasetId, data, params = {}) => this.request({
            path: `/datasets/${datasetId}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get classes of this dataset. **Accepted permissions:** * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datasets
         * @name GetDatasetClasses
         * @summary Get Dataset Classes
         * @request GET:/datasets/{dataset_id}/classes
         * @secure
         */
        getDatasetClasses: (datasetId, params = {}) => this.request({
            path: `/datasets/${datasetId}/classes`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List dataset sources. **Accepted permissions:** * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datasets
         * @name ListDatasetSources
         * @summary List Dataset Sources
         * @request GET:/datasets/{dataset_id}/sources
         * @secure
         */
        listDatasetSources: (datasetId, params = {}) => this.request({
            path: `/datasets/${datasetId}/sources`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    deployments = {
        /**
         * @description List all deployments. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name ListDeployments
         * @summary List Deployments
         * @request GET:/deployments
         * @secure
         */
        listDeployments: (query, params = {}) => this.request({
            path: `/deployments`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a Deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name CreateDeployment
         * @summary Create Deployment
         * @request POST:/deployments
         * @secure
         */
        createDeployment: (data, params = {}) => this.request({
            path: `/deployments`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List deployment fields. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name ListDeploymentFields
         * @summary List Deployment Fields
         * @request GET:/deployments/fields
         * @secure
         */
        listDeploymentFields: (params = {}) => this.request({
            path: `/deployments/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a Deployment placeholder. This Deployment placeholder can have dependencies on resources which do not have valid values yet. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name CreateDeploymentPlaceholder
         * @summary Create Deployment Placeholder
         * @request POST:/deployments/placeholder
         * @secure
         */
        createDeploymentPlaceholder: (data, params = {}) => this.request({
            path: `/deployments/placeholder`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Register an external deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name RegisterExternalDeployment
         * @summary Register External Deployment
         * @request POST:/deployments/register
         * @secure
         */
        registerExternalDeployment: (data, params = {}) => this.request({
            path: `/deployments/register`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name DeleteDeployment
         * @summary Delete Deployment
         * @request DELETE:/deployments/{deployment_id}
         * @secure
         */
        deleteDeployment: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name GetDeployment
         * @summary Get Deployment
         * @request GET:/deployments/{deployment_id}
         * @secure
         */
        getDeployment: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name UpdateDeployment
         * @summary Update Deployment
         * @request PATCH:/deployments/{deployment_id}
         * @secure
         */
        updateDeployment: (deploymentId, data, params = {}) => this.request({
            path: `/deployments/${deploymentId}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get deployment api endpoints info. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name GetDeploymentApiEndpoints
         * @summary Get Deployment Api Endpoints
         * @request GET:/deployments/{deployment_id}/api-endpoints
         * @secure
         */
        getDeploymentApiEndpoints: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/api-endpoints`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get artifacts of a deployment. **Accepted permissions:** * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name GetDeploymentArtifacts
         * @summary Get Deployment Artifacts
         * @request GET:/deployments/{deployment_id}/artifacts
         * @secure
         */
        getDeploymentArtifacts: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/artifacts`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get deployment dependencies. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name GetDeploymentDependencies
         * @summary Get Deployment Dependencies
         * @request GET:/deployments/{deployment_id}/dependencies
         * @secure
         */
        getDeploymentDependencies: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/dependencies`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Log heartbeat for a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name LogHeartbeat
         * @summary Log Heartbeat
         * @request PATCH:/deployments/{deployment_id}/heartbeat
         * @secure
         */
        logHeartbeat: (deploymentId, data, params = {}) => this.request({
            path: `/deployments/${deploymentId}/heartbeat`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description Get logs of a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name GetDeploymentLogs
         * @summary Get Deployment Logs
         * @request GET:/deployments/{deployment_id}/logs
         * @secure
         */
        getDeploymentLogs: (deploymentId, query, params = {}) => this.request({
            path: `/deployments/${deploymentId}/logs`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
        /**
         * @description Save logs to deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name SaveDeploymentLogs
         * @summary Save Deployment Logs
         * @request POST:/deployments/{deployment_id}/logs
         * @secure
         */
        saveDeploymentLogs: (deploymentId, data, params = {}) => this.request({
            path: `/deployments/${deploymentId}/logs`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Get latest status messages of a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name ListDeploymentMessages
         * @summary List Deployment Messages
         * @request GET:/deployments/{deployment_id}/messages
         * @secure
         */
        listDeploymentMessages: (deploymentId, query, params = {}) => this.request({
            path: `/deployments/${deploymentId}/messages`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Log a status message for a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name LogDeploymentMessage
         * @summary Log Deployment Message
         * @request POST:/deployments/{deployment_id}/messages
         * @secure
         */
        logDeploymentMessage: (deploymentId, data, params = {}) => this.request({
            path: `/deployments/${deploymentId}/messages`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description List deployment message fields. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name ListDeploymentMessageFields
         * @summary List Deployment Message Fields
         * @request GET:/deployments/{deployment_id}/messages/fields
         * @secure
         */
        listDeploymentMessageFields: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/messages/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Start a deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name StartDeployment
         * @summary Start Deployment
         * @request POST:/deployments/{deployment_id}/start
         * @secure
         */
        startDeployment: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/start`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update status to deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name UpdateDeploymentStatus
         * @summary Update Deployment Status
         * @request PATCH:/deployments/{deployment_id}/status
         * @secure
         */
        updateDeploymentStatus: (deploymentId, data, params = {}) => this.request({
            path: `/deployments/${deploymentId}/status`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Stop a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name StopDeployment
         * @summary Stop Deployment
         * @request POST:/deployments/{deployment_id}/stop
         * @secure
         */
        stopDeployment: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/stop`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    errors = {
        /**
         * @description List application errors.
         *
         * @tags monitor
         * @name ListErrors
         * @summary List Errors
         * @request GET:/errors
         * @secure
         */
        listErrors: (params = {}) => this.request({
            path: `/errors`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    exampleStreams = {
        /**
         * @description List example streams. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name ListExampleStreams
         * @summary List Example Streams
         * @request GET:/example-streams
         * @secure
         */
        listExampleStreams: (query, params = {}) => this.request({
            path: `/example-streams`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name CreateExampleStream
         * @summary Create Example Stream
         * @request POST:/example-streams
         * @secure
         */
        createExampleStream: (data, params = {}) => this.request({
            path: `/example-streams`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Disable an example stream. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name DeleteExampleStream
         * @summary Delete Example Stream
         * @request DELETE:/example-streams/{example_stream_id}
         * @secure
         */
        deleteExampleStream: (exampleStreamId, query, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}`,
            method: "DELETE",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get example stream. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name GetExampleStream
         * @summary Get Example Stream
         * @request GET:/example-streams/{example_stream_id}
         * @secure
         */
        getExampleStream: (exampleStreamId, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update example stream. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name UpdateExampleStream
         * @summary Update Example Stream
         * @request PATCH:/example-streams/{example_stream_id}
         * @secure
         */
        updateExampleStream: (exampleStreamId, data, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name GetCameraConfigData
         * @summary Get Camera Config Data
         * @request GET:/example-streams/{example_stream_id}/cameras/{camera_id}/config
         * @secure
         */
        getCameraConfigData: (exampleStreamId, cameraId, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}/cameras/${cameraId}/config`,
            method: "GET",
            secure: true,
            ...params,
        }),
        /**
         * @description Update example stream config status. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name UpdateExampleStreamConfigStatus
         * @summary Update Example Stream Config Status
         * @request PUT:/example-streams/{example_stream_id}/config-status
         * @secure
         */
        updateExampleStreamConfigStatus: (exampleStreamId, data, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}/config-status`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Revalidate an example stream. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name RevalidateExampleStream
         * @summary Revalidate Example Stream
         * @request POST:/example-streams/{example_stream_id}/revalidate
         * @secure
         */
        revalidateExampleStream: (exampleStreamId, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}/revalidate`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update example stream status. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name UpdateExampleStreamStatus
         * @summary Update Example Stream Status
         * @request PUT:/example-streams/{example_stream_id}/status
         * @secure
         */
        updateExampleStreamStatus: (exampleStreamId, query, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}/status`,
            method: "PUT",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Stop validation of an example stream. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name StopValidationExampleStream
         * @summary Stop Validation Example Stream
         * @request POST:/example-streams/{example_stream_id}/stop-validation
         * @secure
         */
        stopValidationExampleStream: (exampleStreamId, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}/stop-validation`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name GetValidationLogs
         * @summary Get Validation Logs
         * @request GET:/example-streams/{example_stream_id}/validation-logs
         * @secure
         */
        getValidationLogs: (exampleStreamId, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}/validation-logs`,
            method: "GET",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name AddValidationLogs
         * @summary Add Validation Logs
         * @request PUT:/example-streams/{example_stream_id}/validation-logs
         * @secure
         */
        addValidationLogs: (exampleStreamId, data, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}/validation-logs`,
            method: "PUT",
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
    };
    info = {
        /**
         * @description Get platform info.
         *
         * @tags monitor
         * @name GetInfo
         * @summary Get Info
         * @request GET:/info
         * @secure
         */
        getInfo: (params = {}) => this.request({
            path: `/info`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    jobs = {
        /**
         * @description List all jobs. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name ListJobs
         * @summary List Jobs
         * @request GET:/jobs
         * @secure
         */
        listJobs: (query, params = {}) => this.request({
            path: `/jobs`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Start a job. All parameters (parameters, models, datasets) are linked with the `job_id`. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
         *
         * @tags jobs
         * @name StartJob
         * @summary Start Job
         * @request POST:/jobs
         * @secure
         */
        startJob: (data, params = {}) => this.request({
            path: `/jobs`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List job fields. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name ListJobFields
         * @summary List Job Fields
         * @request GET:/jobs/fields
         * @secure
         */
        listJobFields: (params = {}) => this.request({
            path: `/jobs/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Register an external job. Alternative for start_job, but without actually starting the job. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
         *
         * @tags jobs
         * @name RegisterExternalJob
         * @summary Register External Job
         * @request POST:/jobs/register
         * @secure
         */
        registerExternalJob: (data, params = {}) => this.request({
            path: `/jobs/register`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a job. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags jobs
         * @name DeleteJob
         * @summary Delete Job
         * @request DELETE:/jobs/{job_id}
         * @secure
         */
        deleteJob: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a job. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name GetJob
         * @summary Get Job
         * @request GET:/jobs/{job_id}
         * @secure
         */
        getJob: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get job api endpoints info. **Accepted permissions:** * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION
         *
         * @tags jobs
         * @name GetJobApiEndpoints
         * @summary Get Job Api Endpoints
         * @request GET:/jobs/{job_id}/api-endpoints
         * @secure
         */
        getJobApiEndpoints: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/api-endpoints`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get artifacts of a job. **Accepted permissions:** * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION
         *
         * @tags jobs
         * @name GetJobArtifacts
         * @summary Get Job Artifacts
         * @request GET:/jobs/{job_id}/artifacts
         * @secure
         */
        getJobArtifacts: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/artifacts`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name GetJobCreator
         * @summary Get Job Creator
         * @request GET:/jobs/{job_id}/creator
         * @secure
         */
        getJobCreator: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/creator`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get job dependencies. **Accepted permissions:** * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION
         *
         * @tags jobs
         * @name GetJobDependencies
         * @summary Get Job Dependencies
         * @request GET:/jobs/{job_id}/dependencies
         * @secure
         */
        getJobDependencies: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/dependencies`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get logs of a job. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name GetJobLogs
         * @summary Get Job Logs
         * @request GET:/jobs/{job_id}/logs
         * @secure
         */
        getJobLogs: (jobId, query, params = {}) => this.request({
            path: `/jobs/${jobId}/logs`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
        /**
         * @description Save logs to job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name SaveJobLogs
         * @summary Save Job Logs
         * @request PUT:/jobs/{job_id}/logs
         * @secure
         */
        saveJobLogs: (jobId, data, params = {}) => this.request({
            path: `/jobs/${jobId}/logs`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Get latest status messages of a job. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name ListJobMessages
         * @summary List Job Messages
         * @request GET:/jobs/{job_id}/messages
         * @secure
         */
        listJobMessages: (jobId, query, params = {}) => this.request({
            path: `/jobs/${jobId}/messages`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Log a status message for a job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name LogJobMessage
         * @summary Log Job Message
         * @request POST:/jobs/{job_id}/messages
         * @secure
         */
        logJobMessage: (jobId, data, params = {}) => this.request({
            path: `/jobs/${jobId}/messages`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description List job message fields. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name ListJobMessageFields
         * @summary List Job Message Fields
         * @request GET:/jobs/{job_id}/messages/fields
         * @secure
         */
        listJobMessageFields: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/messages/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update the metadata of a job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name UpdateJobMetadata
         * @summary Update Job Metadata
         * @request PUT:/jobs/{job_id}/metadata
         * @secure
         */
        updateJobMetadata: (jobId, data, params = {}) => this.request({
            path: `/jobs/${jobId}/metadata`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Update status to job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name UpdateJobStatus
         * @summary Update Job Status
         * @request POST:/jobs/{job_id}/status
         * @secure
         */
        updateJobStatus: (jobId, data, params = {}) => this.request({
            path: `/jobs/${jobId}/status`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Stop a job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name StopJob
         * @summary Stop Job
         * @request POST:/jobs/{job_id}/stop
         * @secure
         */
        stopJob: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/stop`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    livez = {
        /**
         * @description Get application heartbeat.
         *
         * @tags monitor
         * @name GetHeartbeat
         * @summary Get Heartbeat
         * @request GET:/livez
         * @secure
         */
        getHeartbeat: (params = {}) => this.request({
            path: `/livez`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    logs = {
        /**
         * @description Prepare server logs.
         *
         * @tags monitor
         * @name PrepareLogs
         * @summary Prepare Logs
         * @request POST:/logs
         * @secure
         */
        prepareLogs: (query, params = {}) => this.request({
            path: `/logs`,
            method: "POST",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Download server logs.
         *
         * @tags monitor
         * @name DownloadLogs
         * @summary Download Logs
         * @request GET:/logs/{zip_filename}
         * @secure
         */
        downloadLogs: (zipFilename, params = {}) => this.request({
            path: `/logs/${zipFilename}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    platformConnection = {
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name DeletePlatformConnection
         * @summary Delete Platform Connection
         * @request DELETE:/platform-connection
         * @secure
         */
        deletePlatformConnection: (params = {}) => this.request({
            path: `/platform-connection`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name GetPlatformConnection
         * @summary Get Platform Connection
         * @request GET:/platform-connection
         * @secure
         */
        getPlatformConnection: (params = {}) => this.request({
            path: `/platform-connection`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name CreatePlatformConnection
         * @summary Create Platform Connection
         * @request POST:/platform-connection
         * @secure
         */
        createPlatformConnection: (data, params = {}) => this.request({
            path: `/platform-connection`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ListAlgorithmsFromConnection
         * @summary List Algorithms From Connection
         * @request GET:/platform-connection/algorithms
         * @secure
         */
        listAlgorithmsFromConnection: (query, params = {}) => this.request({
            path: `/platform-connection/algorithms`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ListDeploymentsFromConnection
         * @summary List Deployments From Connection
         * @request GET:/platform-connection/deployments
         * @secure
         */
        listDeploymentsFromConnection: (query, params = {}) => this.request({
            path: `/platform-connection/deployments`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name GetDeploymentDependenciesFromConnection
         * @summary Get Deployment Dependencies From Connection
         * @request GET:/platform-connection/deployments/{deployment_id}/dependencies
         * @secure
         */
        getDeploymentDependenciesFromConnection: (deploymentId, params = {}) => this.request({
            path: `/platform-connection/deployments/${deploymentId}/dependencies`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name GetPlatformConnectionsNetworkOverview
         * @summary Get Platform Connections Network Overview
         * @request GET:/platform-connection/network-overview
         * @secure
         */
        getPlatformConnectionsNetworkOverview: (params = {}) => this.request({
            path: `/platform-connection/network-overview`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ListDeployments
         * @summary List Deployments
         * @request GET:/platform-connection/platform-deployments
         * @secure
         */
        listDeployments: (query, params = {}) => this.request({
            path: `/platform-connection/platform-deployments`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name CreateDeploymentsBatch
         * @summary Create Deployments Batch
         * @request POST:/platform-connection/platform-deployments
         * @secure
         */
        createDeploymentsBatch: (data, params = {}) => this.request({
            path: `/platform-connection/platform-deployments`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name DeleteDeployment
         * @summary Delete Deployment
         * @request DELETE:/platform-connection/platform-deployments/{id}
         * @secure
         */
        deleteDeployment: (id, query, params = {}) => this.request({
            path: `/platform-connection/platform-deployments/${id}`,
            method: "DELETE",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a platform deployment by ID. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name GetDeployment
         * @summary Get Deployment
         * @request GET:/platform-connection/platform-deployments/{id}
         * @secure
         */
        getDeployment: (id, params = {}) => this.request({
            path: `/platform-connection/platform-deployments/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name UpdateDeploymentActualStatus
         * @summary Update Deployment Actual Status
         * @request PATCH:/platform-connection/platform-deployments/{id}/actual-status
         * @secure
         */
        updateDeploymentActualStatus: (id, data, params = {}) => this.request({
            path: `/platform-connection/platform-deployments/${id}/actual-status`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name UpdateDeploymentDesiredStatus
         * @summary Update Deployment Desired Status
         * @request PATCH:/platform-connection/platform-deployments/{id}/desired-status
         * @secure
         */
        updateDeploymentDesiredStatus: (id, data, params = {}) => this.request({
            path: `/platform-connection/platform-deployments/${id}/desired-status`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List all projects from the latest hub connection that are compatible with the current project. Compatible projects are projects with the same algorithm type. If no connection id is provided, it defaults to the latest one that was set up. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ListProjectsFromConnection
         * @summary List Projects From Connection
         * @request GET:/platform-connection/projects
         * @secure
         */
        listProjectsFromConnection: (query, params = {}) => this.request({
            path: `/platform-connection/projects`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD EDGE * DATA_UPLOAD MODEL_CREATION * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name GetParametersResourceDataFromConnection
         * @summary Get Parameters Resource Data From Connection
         * @request GET:/platform-connection/resources/parameters/{resource_id}/data
         * @secure
         */
        getParametersResourceDataFromConnection: (resourceId, params = {}) => this.request({
            path: `/platform-connection/resources/parameters/${resourceId}/data`,
            method: "GET",
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ValidatePlatformConnection
         * @summary Validate Platform Connection
         * @request GET:/platform-connection/validate
         * @secure
         */
        validatePlatformConnection: (params = {}) => this.request({
            path: `/platform-connection/validate`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ValidateCredentials
         * @summary Validate Credentials
         * @request POST:/platform-connection/validate
         * @secure
         */
        validateCredentials: (data, params = {}) => this.request({
            path: `/platform-connection/validate`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description This endpoint is to be used to get the desired deployments for a platform. Typically, it is called by the agent that needs to know the desired deployments for a platform. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name GetDesiredDeployments
         * @summary Get Desired Deployments
         * @request GET:/platform-connection/{platform_id}/platform-deployments/desired
         * @secure
         */
        getDesiredDeployments: (platformId, params = {}) => this.request({
            path: `/platform-connection/${platformId}/platform-deployments/desired`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    projects = {
        /**
         * @description List all projects. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name ListProjects
         * @summary List Projects
         * @request GET:/projects
         * @secure
         */
        listProjects: (query, params = {}) => this.request({
            path: `/projects`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a project. **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags projects
         * @name CreateProject
         * @summary Create Project
         * @request POST:/projects
         * @secure
         */
        createProject: (data, params = {}) => this.request({
            path: `/projects`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List project fields. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name ListProjectFields
         * @summary List Project Fields
         * @request GET:/projects/fields
         * @secure
         */
        listProjectFields: (params = {}) => this.request({
            path: `/projects/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List all project metadata. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name ListProjectMetadata
         * @summary List Project Metadata
         * @request GET:/projects/metadata
         * @secure
         */
        listProjectMetadata: (params = {}) => this.request({
            path: `/projects/metadata`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a project by its name. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name GetProjectByName
         * @summary Get Project By Name
         * @request GET:/projects/name/{project_name}
         * @secure
         */
        getProjectByName: (projectName, params = {}) => this.request({
            path: `/projects/name/${projectName}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Check project name's existence. **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags projects
         * @name IsProjectNameAvailable
         * @summary Is Project Name Available
         * @request GET:/projects/name/{project_name}/availability
         * @secure
         */
        isProjectNameAvailable: (projectName, params = {}) => this.request({
            path: `/projects/name/${projectName}/availability`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a project. **Accepted permissions:** * INFERENCE MODEL_CREATION PROJECT_CREATION * MODEL_CREATION PROJECT_CREATION SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name DeleteProject
         * @summary Delete Project
         * @request DELETE:/projects/{project_id}
         * @secure
         */
        deleteProject: (projectId, params = {}) => this.request({
            path: `/projects/${projectId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a project. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name GetProject
         * @summary Get Project
         * @request GET:/projects/{project_id}
         * @secure
         */
        getProject: (projectId, params = {}) => this.request({
            path: `/projects/${projectId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a project. **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags projects
         * @name UpdateProject
         * @summary Update Project
         * @request PATCH:/projects/{project_id}
         * @secure
         */
        updateProject: (projectId, data, params = {}) => this.request({
            path: `/projects/${projectId}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a default algorithm in project. **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags projects
         * @name UpdateProjectDefaultAlgorithm
         * @summary Update Project Default Algorithm
         * @request PATCH:/projects/{project_id}/algorithm
         * @secure
         */
        updateProjectDefaultAlgorithm: (projectId, data, params = {}) => this.request({
            path: `/projects/${projectId}/algorithm`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get default project example definitions. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name GetDefaultProjectExampleDefinitions
         * @summary Get Default Project Example Definitions
         * @request GET:/projects/{project_id}/example-definitions
         * @secure
         */
        getDefaultProjectExampleDefinitions: (projectId, params = {}) => this.request({
            path: `/projects/${projectId}/example-definitions`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get project thumbnail. Supports authorization via ?token. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name GetProjectThumbnail
         * @summary Get Project Thumbnail
         * @request GET:/projects/{project_id}/thumbnail
         * @secure
         */
        getProjectThumbnail: (projectId, query, params = {}) => this.request({
            path: `/projects/${projectId}/thumbnail`,
            method: "GET",
            query: query,
            secure: true,
            format: "blob",
            ...params,
        }),
    };
    prometheus = {
        /**
         * No description
         *
         * @tags monitor
         * @name GetPrometheusMetrics
         * @summary Get Prometheus Metrics
         * @request GET:/prometheus
         * @secure
         */
        getPrometheusMetrics: (params = {}) => this.request({
            path: `/prometheus`,
            method: "GET",
            secure: true,
            ...params,
        }),
    };
    resources = {
        /**
         * @description List resources. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name ListResources
         * @summary List Resources
         * @request GET:/resources/
         * @secure
         */
        listResources: (query, params = {}) => this.request({
            path: `/resources/`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List blob resources. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name ListBlobResources
         * @summary List Blob Resources
         * @request GET:/resources/blobs
         * @secure
         */
        listBlobResources: (query, params = {}) => this.request({
            path: `/resources/blobs`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create generic blob resource and upload data via returned upload url. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name CreateBlobResource
         * @summary Create Blob Resource
         * @request POST:/resources/blobs
         * @secure
         */
        createBlobResource: (data, params = {}) => this.request({
            path: `/resources/blobs`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get blob resource info. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetBlobResourceInfo
         * @summary Get Blob Resource Info
         * @request GET:/resources/blobs/{resource_id}
         * @secure
         */
        getBlobResourceInfo: (resourceId, params = {}) => this.request({
            path: `/resources/blobs/${resourceId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Override blob resource metadata. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name OverrideBlobResourceMetadata
         * @summary Override Blob Resource Metadata
         * @request PUT:/resources/blobs/{resource_id}
         * @secure
         */
        overrideBlobResourceMetadata: (resourceId, data, params = {}) => this.request({
            path: `/resources/blobs/${resourceId}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get blob resource data. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetBlobResourceData
         * @summary Get Blob Resource Data
         * @request GET:/resources/blobs/{resource_id}/data
         * @secure
         */
        getBlobResourceData: (resourceId, query, params = {}) => this.request({
            path: `/resources/blobs/${resourceId}/data`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description Put blob resource data. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name PutBlobResourceData
         * @summary Put Blob Resource Data
         * @request PUT:/resources/blobs/{resource_id}/data
         * @secure
         */
        putBlobResourceData: (resourceId, data, params = {}) => this.request({
            path: `/resources/blobs/${resourceId}/data`,
            method: "PUT",
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List resource fields. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name ListResourceFields
         * @summary List Resource Fields
         * @request GET:/resources/fields
         * @secure
         */
        listResourceFields: (params = {}) => this.request({
            path: `/resources/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List model resources. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name ListModelResources
         * @summary List Model Resources
         * @request GET:/resources/models
         * @secure
         */
        listModelResources: (query, params = {}) => this.request({
            path: `/resources/models`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create model resource and upload data via returned upload url. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name CreateModelResource
         * @summary Create Model Resource
         * @request POST:/resources/models
         * @secure
         */
        createModelResource: (data, params = {}) => this.request({
            path: `/resources/models`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get model resource info. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetModelResourceInfo
         * @summary Get Model Resource Info
         * @request GET:/resources/models/{resource_id}
         * @secure
         */
        getModelResourceInfo: (resourceId, params = {}) => this.request({
            path: `/resources/models/${resourceId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Override models resource metadata. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name OverrideModelResourceMetadata
         * @summary Override Model Resource Metadata
         * @request PUT:/resources/models/{resource_id}
         * @secure
         */
        overrideModelResourceMetadata: (resourceId, data, params = {}) => this.request({
            path: `/resources/models/${resourceId}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get model resource data. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetModelResourceData
         * @summary Get Model Resource Data
         * @request GET:/resources/models/{resource_id}/data
         * @secure
         */
        getModelResourceData: (resourceId, query, params = {}) => this.request({
            path: `/resources/models/${resourceId}/data`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description Put model resource data. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name PutModelResourceData
         * @summary Put Model Resource Data
         * @request PUT:/resources/models/{resource_id}/data
         * @secure
         */
        putModelResourceData: (resourceId, data, params = {}) => this.request({
            path: `/resources/models/${resourceId}/data`,
            method: "PUT",
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List parameters resources. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name ListParametersResources
         * @summary List Parameters Resources
         * @request GET:/resources/parameters
         * @secure
         */
        listParametersResources: (query, params = {}) => this.request({
            path: `/resources/parameters`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a parameters resource. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name CreateParametersResource
         * @summary Create Parameters Resource
         * @request POST:/resources/parameters
         * @secure
         */
        createParametersResource: (data, params = {}) => this.request({
            path: `/resources/parameters`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Create parameters resource and upload data via returned upload url. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name CreateParametersResourceWithUploadUrl
         * @summary Create Parameters Resource With Upload Url
         * @request POST:/resources/parameters/metadata
         * @secure
         */
        createParametersResourceWithUploadUrl: (data, params = {}) => this.request({
            path: `/resources/parameters/metadata`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get parameters resource info. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetParametersResourceInfo
         * @summary Get Parameters Resource Info
         * @request GET:/resources/parameters/{resource_id}
         * @secure
         */
        getParametersResourceInfo: (resourceId, params = {}) => this.request({
            path: `/resources/parameters/${resourceId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Override parameters resource metadata. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name OverrideParametersResourceMetadata
         * @summary Override Parameters Resource Metadata
         * @request PUT:/resources/parameters/{resource_id}
         * @secure
         */
        overrideParametersResourceMetadata: (resourceId, data, params = {}) => this.request({
            path: `/resources/parameters/${resourceId}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get parameters resource data. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetParametersResourceData
         * @summary Get Parameters Resource Data
         * @request GET:/resources/parameters/{resource_id}/data
         * @secure
         */
        getParametersResourceData: (resourceId, query, params = {}) => this.request({
            path: `/resources/parameters/${resourceId}/data`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description Put parameters resource data. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name PutParametersResourceData
         * @summary Put Parameters Resource Data
         * @request PUT:/resources/parameters/{resource_id}/data
         * @secure
         */
        putParametersResourceData: (resourceId, data, params = {}) => this.request({
            path: `/resources/parameters/${resourceId}/data`,
            method: "PUT",
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get parameters resource definition. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetParametersResourceDefinition
         * @summary Get Parameters Resource Definition
         * @request GET:/resources/parameters/{resource_id}/definition
         * @secure
         */
        getParametersResourceDefinition: (resourceId, params = {}) => this.request({
            path: `/resources/parameters/${resourceId}/definition`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete resource. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name DeleteResource
         * @summary Delete Resource
         * @request DELETE:/resources/{resource_id}
         * @secure
         */
        deleteResource: (resourceId, params = {}) => this.request({
            path: `/resources/${resourceId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    schemas = {
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags schemas
         * @name GetDatapoolDefinition
         * @summary Get Datapool Definition
         * @request GET:/schemas/datapool/{definition_id}
         * @secure
         */
        getDatapoolDefinition: (definitionId, params = {}) => this.request({
            path: `/schemas/datapool/${definitionId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    sse = {
        /**
         * No description
         *
         * @tags sse
         * @name GetEvents
         * @summary Get Events
         * @request GET:/sse
         * @secure
         */
        getEvents: (query, params = {}) => this.request({
            path: `/sse`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
    };
    storageCapacity = {
        /**
         * No description
         *
         * @tags storage_capacity
         * @name GetStorageCapacities
         * @summary Get Storage Capacities
         * @request GET:/storage-capacity
         * @secure
         */
        getStorageCapacities: (params = {}) => this.request({
            path: `/storage-capacity`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    termsAndConditions = {
        /**
         * @description Returns the terms and conditions as a PDF. If the terms and conditions have not been overridden, the default terms and conditions should be shown.
         *
         * @tags monitor
         * @name GetTermsAndConditions
         * @summary Get Terms And Conditions
         * @request GET:/terms-and-conditions/pdf
         * @secure
         */
        getTermsAndConditions: (query, params = {}) => this.request({
            path: `/terms-and-conditions/pdf`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
    };
    version = {
        /**
         * @description [DEPRECATED] Returns the application version. Use `/info` instead.
         *
         * @tags monitor
         * @name GetVersion
         * @summary Get Version
         * @request GET:/version
         * @deprecated
         * @secure
         */
        getVersion: (params = {}) => this.request({
            path: `/version`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    viewTemplates = {
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name ListExampleStreamViewTemplates
         * @summary List Example Stream View Templates
         * @request GET:/view-templates
         * @secure
         */
        listExampleStreamViewTemplates: (params = {}) => this.request({
            path: `/view-templates`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    workflows = {
        /**
         * @description List all workflows. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name ListWorkflows
         * @summary List Workflows
         * @request GET:/workflows
         * @secure
         */
        listWorkflows: (query, params = {}) => this.request({
            path: `/workflows`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Start a workflow. All parameters (parameters, models, datasets) are linked with the `workflow_id`. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
         *
         * @tags workflows
         * @name StartWorkflow
         * @summary Start Workflow
         * @request POST:/workflows
         * @secure
         */
        startWorkflow: (data, params = {}) => this.request({
            path: `/workflows`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List workflow fields. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name ListWorkflowFields
         * @summary List Workflow Fields
         * @request GET:/workflows/fields
         * @secure
         */
        listWorkflowFields: (params = {}) => this.request({
            path: `/workflows/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Register an external workflow. Alternative for start_workflow, but without actually starting the workflow. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
         *
         * @tags workflows
         * @name RegisterExternalWorkflow
         * @summary Register External Workflow
         * @request POST:/workflows/register
         * @secure
         */
        registerExternalWorkflow: (data, params = {}) => this.request({
            path: `/workflows/register`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a workflow. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags workflows
         * @name DeleteWorkflow
         * @summary Delete Workflow
         * @request DELETE:/workflows/{workflow_id}
         * @secure
         */
        deleteWorkflow: (workflowId, params = {}) => this.request({
            path: `/workflows/${workflowId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a workflow. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name GetWorkflow
         * @summary Get Workflow
         * @request GET:/workflows/{workflow_id}
         * @secure
         */
        getWorkflow: (workflowId, params = {}) => this.request({
            path: `/workflows/${workflowId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update the metadata of a workflow. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name UpdateWorkflowMetadata
         * @summary Update Workflow Metadata
         * @request PUT:/workflows/{workflow_id}/metadata
         * @secure
         */
        updateWorkflowMetadata: (workflowId, data, params = {}) => this.request({
            path: `/workflows/${workflowId}/metadata`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Update status of workflow. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name UpdateWorkflowStatus
         * @summary Update Workflow Status
         * @request POST:/workflows/{workflow_id}/status
         * @secure
         */
        updateWorkflowStatus: (workflowId, data, params = {}) => this.request({
            path: `/workflows/${workflowId}/status`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Stop a workflow. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name StopWorkflow
         * @summary Stop Workflow
         * @request POST:/workflows/{workflow_id}/stop
         * @secure
         */
        stopWorkflow: (workflowId, params = {}) => this.request({
            path: `/workflows/${workflowId}/stop`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
    };
}
//# sourceMappingURL=data:application/json;base64,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